import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSnapshot } from "valtio";
import { registrationStore } from "@/features/auth/store";
import { PersonalSchema, TPersonalSchema } from "@/features/auth/forms/schema";

import PhoneNumberInput from "@/components/form-controls/PhoneInput";
import SelectInput from "@/components/form-controls/SelectInput";
import TextInput from "@/components/form-controls/TextInput";
import RegisterHeader from "@/features/auth/fragments/registration-header";
import SubmitButton from "@/features/auth/forms/submit-button";




const RegisterPersonalForm = () => {
    const navigate = useNavigate();
    const store = useSnapshot(registrationStore);
    const { register, handleSubmit, control, formState: { errors }} = useForm({
        resolver: yupResolver(PersonalSchema),
        defaultValues: store.personal ? store.personal: undefined
    })

    const submit = (data: TPersonalSchema) => {
        store.setPersonal(data);
        navigate("/auth/register/identity");
    }

    return (
        <div className="space-y-12">
            <RegisterHeader 
                heading={"Provide Your Personal Details"}
                description={"Please enter your personal details."}
            />

            <form className="grid grid-cols-2 gap-4" onSubmit={handleSubmit(submit)}>
                <SelectInput 
                    label="Saluation"
                    displayName="label"
                    valueName="value"
                    options={[
                        { label: "Mr", value: "mr" },
                        { label: "Mrs", value: "mrs" },
                        { label: "Sir", value: "sir" },
                        { label: "Madam", value: "madam" }
                    ]}
                    className="col-span-2"
                    error={errors.salutation?.message?.toString()}
                    register={register("salutation")}
                    required
                />

                <TextInput 
                    label="First Name"
                    placeholder="enter your first name"
                    error={errors.firstName?.message?.toString()}
                    register={register("firstName")}
                    required
                />

                <TextInput 
                    label="Last name"
                    placeholder="enter your last name"
                    error={errors.lastName?.message?.toString()}
                    register={register("lastName")}
                    required
                />

                <TextInput 
                    label="Email address"
                    placeholder="e.g. mosha.peter@gmail.com"
                    type="email"
                    error={errors.email?.message?.toString()}
                    register={register("email")}
                    required
                />

                <PhoneNumberInput 
                    name="phone"
                    label="Phone Number"
                    placeholder="enter your tin number"
                    control={control}
                    required
                />

                <TextInput 
                    label="Password"
                    type="password"
                    className="col-span-2"
                    error={errors.password?.message?.toString()}
                    register={register("password")}
                    required
                />

                <TextInput 
                    label="Re-enter password"
                    type="password"
                    className="col-span-2"
                    error={errors.confirmPassword?.message?.toString()}
                    register={register("confirmPassword")}
                    required
                />

                <SubmitButton 
                    hasPrev={false}
                />
            </form>
        </div>
    )
}

export default RegisterPersonalForm